import React, { useCallback, useEffect, useState } from 'react';
import { getPrivateCoachingData } from './api/getPrivateCoachingData';
import PrivateCoachingCard from './components/PrivateCoachingCard';
import { PopupPrivateCoachingForm } from '../../components/PopupPrivateCoachingForm';
import './PrivateCoaching.scss';

export const PrivateCoaching = () => {
  const [data, setData] = useState([]);
  const [showPopup, setShowPopup] = useState(false);

  const getCoachesData = useCallback(async () => {
    const data = await getPrivateCoachingData();
    setData(data);
  }, [setData]);

  useEffect(() => {
    getCoachesData();
  }, [getCoachesData]);

  return (
    <div className="PrivateCoaching">
      <div className="PrivateCoaching__content">
        <h1 className="PrivateCoaching__title">Private Coaching</h1>
        <div className="PrivateCoaching__wrapper">
          {data.map((item) => (
            <PrivateCoachingCard
              showPopup={() => setShowPopup(true)}
              {...item}
            />
          ))}
        </div>
        {showPopup && (
          <PopupPrivateCoachingForm closeModal={() => setShowPopup(false)} />
        )}
      </div>
    </div>
  );
};
